import React, { useEffect, useRef } from "react"
import ReactInputVerificationCode from "react-input-verification-code"
import "./ConfirmCode.css"

interface IConfirmCodeProps {
  setConfirmValue: React.Dispatch<React.SetStateAction<string>>,
  length: number,
  /** Когда становится true — автоматически переводим фокус в поле ввода кода. */
  focusOn?: boolean,
  /** Вызывается по нажатию Enter в поле кода (например, для отправки формы). */
  onEnter?: () => void,
}


export const ConfirmCode: React.FC<IConfirmCodeProps> = ({ setConfirmValue, length, focusOn, onEnter }) => {
  const wrapRef = useRef<HTMLDivElement>(null)

  const handleChange = (value:string) => {
    setConfirmValue(value)
  }

  // Как только форма кода открывается — ставим каретку в поле, чтобы пользователю не нужно было кликать.
  // Фокусируем первый "квадрат" (item), а не скрытый input: библиотека вешает onFocus именно на items,
  // и только через него выставляется активный индекс и активируется ввод.
  useEffect(() => {
    if (!focusOn) return
    const t = setTimeout(() => {
      const firstItem = wrapRef.current?.querySelector<HTMLElement>(".ReactInputVerificationCode__item")
      firstItem?.focus()
    }, 0)
    return () => clearTimeout(t)
  }, [focusOn])

  return (
    <div
      className="form__confirm-code"
      ref={wrapRef}
      onKeyDown={(e) => { if (e.key === "Enter") onEnter?.() }}
    >
      <ReactInputVerificationCode
        placeholder=""
        onChange={handleChange}
        length={length}
      />
    </div>
  )
}
